<template>
  <section class="advantage section">
    <div class="container">
      <div class="section-header">
        <span class="section-label">技术优势</span>
        <h2 class="section-title">为什么选择小智科技</h2>
        <p class="section-desc">
          深耕政务AI领域多年，以自研技术为核心，为政府客户提供安全、可靠、可落地的智能化方案
        </p>
      </div>

      <div class="advantage__grid">
        <div
          v-for="item in advantages"
          :key="item.title"
          class="advantage__card"
        >
          <div class="advantage__icon">{{ item.icon }}</div>
          <h3 class="advantage__title">{{ item.title }}</h3>
          <p class="advantage__desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { advantages } from '../data/site'

export default {
  name: 'AdvantageSection',
  data() {
    return { advantages }
  }
}
</script>

<style scoped>
.advantage {
  background: #fff;
}

.advantage__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}

.advantage__card {
  padding: 32px;
  border-radius: 12px;
  border: 1px solid #eef1f6;
  transition: all 0.3s;
}

.advantage__card:hover {
  border-color: #0052d9;
  box-shadow: 0 8px 32px rgba(0, 82, 217, 0.08);
}

.advantage__icon {
  font-size: 32px;
  margin-bottom: 16px;
}

.advantage__title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.advantage__desc {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
}

@media (max-width: 960px) {
  .advantage__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .advantage__grid {
    grid-template-columns: 1fr;
  }
}
</style>
